<template>
	<div>
		<nav-bar></nav-bar>
		<con-tab></con-tab>
		<div class="bg">
			<div class="banxin ">
				<div class="tongbox">
					<div class="tongleft">
						<div class="tongtop">
							<div class="qibox">
								<div class="qileft">
									仪器分类：
								</div>
								<div class="qiyou">
									<div class="qili " :class="{qiactive : isActive == -1}" @click="yiqiTab(-1)">
										全部
									</div>
									<div class="qili" v-for="(item , index) in yiqiList" :key="index" @click="yiqiTab(index,item.id)" :class="{qiactive : isActive == index}">
										{{item.title}}
									</div>
								</div>
							</div>
							<div class="qibox">
								<div class="zhuleft" >
									主要测试和研究领域：
								</div>
								<div class="zhuyou" :class="{zhuyouact : zhuyouact}">
									<div class="zhulileft" >
										<div class="qili " :class="{qiactive : jiuActive == -1}" @click="jiuTab(-1)">
											全部
										</div>
										<div class="qili" v-for="(item , index) in jiuList" :key="index" @click="jiuTab(index,item.id)" :class="{qiactive : jiuActive == index}">
											{{item.title}}
										</div>
									</div>
									<div class="kaibox" @click="showmore">
										<div class="kaititle" v-if="zhuyouact">
											收起
										</div>
										<div class="kaititle" v-else>
											展开
										</div>
										<img src="../../assets/img/images/heisan_03.png" class="kaipic" alt="" />
									</div>
								</div>
								
							</div>
							
							<div class="qibox">
								<div class="yiyileft" >
									创新券情况：
								</div>
								<div class="zhuyou" :class="{zhuyouact : zhuyouact}">
									<div class="zhulileft" >
										<div class="qili" v-for="(item , index) in chuangList" :key="index" @click="chuangTab(index)" :class="{qiactive : chuangActive == index}">
											{{item.title}}
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="zongbox">
							<div class="zongtop">
								<div class="zongtitle">
									综合排序
								</div>
							</div>
							<div class="pinbox">
								<div class="pinli" v-for="(item,index) in paiList" @click="goTodetail(item.id)">
									<img :src="item.image" class="pinpic" alt="" />
									<div class="pintitle oneline">
										{{item.title}}
									</div>
									<div class="pinyao">
										<div class="yaotxt" v-if="item.research_id">
											{{item.research_id}}
										</div>
										<div class="yaotxt" v-else>
											暂无
										</div>
									</div>
									<div class="pintxt">
										仪器分类：
										<span>{{item.category.title}}</span>
									</div>
									<div class="pintxt">
										是否出具检测报告：
										<span>{{item.is_report}}</span>
									</div>
								</div>
							</div>
							<div class="fenbox">
								<div class="pagination">
								  <pagination
								    class="pages"
								    v-show="total > 0"
								    :total="total"
								    layout="prev, pager, next"
								    :page.sync="pageNum"
								    :limit.sync="pageSize"
								    @pagination="getList"
								  />
								</div>
							</div>
						</div>
					</div>
					
					<div class="tongright">
						<div class="hottop">
							<img src="../../assets/img/images/hot_03.png" class="firepic" alt="" />
							<div class="hottitle">
								热门仪器
							</div>
							<div class="chengline"></div>
						</div>
						<div class="zhenbox" v-for="(item,index) in shiList" @click="goTodetail(item.id)">
							<img :src="item.image" class="zhenpic" alt="" />
							<div class="zhenyou">
								<div class="zhentitle oneline">
									{{item.title}}
								</div>
								<div class="dantxt oneline">
									所在单位：
									<span>{{item.company}}</span>
								</div>
								<div class="dantxt oneline">
									是否出具检测报告：
									<span>{{item.is_report}}</span>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<tab-bar></tab-bar>
	</div>
</template>

<script>
	import TabBar from "../../components/common/TabBar";
	import ConTab from "../../components/common/ConTab";
	import NavBar from '../../components/common/NavBar';
	import Pagination from "@/common/Pagination";
	import NeedJc from "./base/NeedJc";
	import { yiqi_fenlie,research,yiqi_list } from "@/common/js/api";
	import {shiyan_list} from '../common/js/api';
	export default {
		name: "Needjc",
		components: {
			NavBar,
			NeedJc,
			ConTab,
			TabBar,
			Pagination
		},
		data() {
			return {
				// 仪器分类
				yiqiList: [],
				isActive: -1,
				// 主要测试和研究领域
				jiuList: [],
				jiuActive: -1,
				zhuyouact:false,
				// 创新券情况
				chuangList: [
					{id: 1,title: '全部', },
					{id: 2, title: '可使用',},
					{id: 3, title: '不可使用',}
				],
				paiList:[],
				chuangActive: 0,
				total: 0,
				pageSize: 9,
				pageNum: 1,
				category_id:'',
				research_id:'',
				is_coupon:'',
				shiList:[]
			};
		},
		created() {
			this.getfenlei()
			this.getlingyu()
			this.getList()
			this.shiyan()
		},
		methods: {
			shiyan() {
				shiyan_list({})
					.then(res => {
						this.shiList = res.data
					})
					.catch(err => {});
			},
			// 仪器列表
			getList() {
				yiqi_list({
					page:this.pageNum,
					limit:this.pageSize,
					category_id:this.category_id,
					research_id:this.research_id,
					is_coupon:this.is_coupon
				})
					.then(res => {
						console.log(res,'=============+++++++')
						this.paiList = res.data.data
						this.total = res.data.total
					})
					.catch(err => {});
			},
			// 仪器分类
			yiqiTab(index,id) {
				this.isActive = index
				if(this.isActive == -1){
					this.category_id = ''
					this.getList()
				}else{
					this.category_id = id
					this.getList()
				}
			},
			getfenlei() {
				yiqi_fenlie({})
					.then(res => {
						this.yiqiList = res.data
					})
					.catch(err => {});
			},
			// 主要测试和研究领域
			jiuTab(index,id) {
				this.jiuActive = index
				if(this.jiuActive == -1){
					this.research_id = ''
					this.getList()
				}else{
					this.research_id = id
					this.getList()
				}
			},
			getlingyu() {
				research({})
					.then(res => {
						this.jiuList = res.data
					})
					.catch(err => {});
			},
			// 创新券情况
			chuangTab(index) {
				this.chuangActive = index
				if(index==0){
					this.is_coupon = ''
					this.getList()
				}else if(index==1){
					this.is_coupon = '1'
					this.getList()
				}else if(index==2){
					this.is_coupon = '-1'
					this.getList()
				}
			},
			showmore(){
				this.zhuyouact = !this.zhuyouact
			},
			goTodetail(id){
				this.$router.push({
					path: '/devicedetail',
					query: {
						id: id
					}
				});
			}
		},
		mounted() {},
	}
</script>

<style scoped lang="less">
	.bg{
		background-color: #f6f6f6;
		margin-top: 136px;
	}
	.tongbox {
		padding: 20px 0 60px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.tongleft {
			width: 1025px;
			flex-shrink: 0;
			.tongtop {
				background-color: #ffffff;
				margin-bottom: 20px;
				.qibox{
					display: flex;
					align-items: inherit;
					border-bottom: 1px solid #eeeeee;
					.qileft{
						width: 110px;
						text-align: center;
						background-color: #f2f9fe;
						font-size: 14px;
						color: #2b3151;
						padding: 18px 5px 0;
						line-height: 25px;
						flex-shrink: 0;
					}
					.qiyou{
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						padding: 23px 100px 0 20px ;
						.qili{
							font-size: 14px;
							color: #222222;
							margin: 0 30px 35px 0;
							cursor: pointer;
						}
						.qiactive{
							color: #0289f4;
						}
					}
					.zhuleft{
						width: 110px;
						text-align: center;
						background-color: #f2f9fe;
						font-size: 14px;
						color: #2b3151;
						padding: 7px 5px 0;
						line-height: 25px;
						flex-shrink: 0;
					}
					.yiyileft{
						width: 110px;
						text-align: center;
						background-color: #f2f9fe;
						font-size: 14px;
						color: #2b3151;
						padding: 0 5px 0;
						line-height: 60px;
						flex-shrink: 0;
					}
					.zhuyou{
						display: flex;
						align-items: center;
						justify-content: space-between;
						height: 60px;
						overflow: hidden;
						.zhulileft{
							display: flex;
							align-items: center;
							flex-wrap: wrap;
							padding: 0 100px 0 20px;
							height: 60px;
							.qili{
								font-size: 14px;
								color: #222222;
								cursor: pointer;
								line-height: 60px;
								margin-right: 30px;
							}
							.qiactive{
								color: #0289f4;
							}
						}
						.qiactive{
							color: #0289f4;
						}
						.kaibox{
							width: 60px;
							height: 20px;
							background-color: #f9f9f9;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-right: 55px;
							flex-shrink: 0;
							cursor: pointer;
							.kaititle{
								font-size: 13px;
								color: #222222;
								padding-right: 5px;
							}
							.kaipic{
								width: 7px;
								height: 5px;
							}
						}
					}
					.zhuyouact{
						height: auto !important;
						align-items: flex-start;
						padding-top: 23px;
						.zhulileft{
							display: flex;
							align-items: center;
							flex-wrap: wrap;
							padding: 0 100px 0 20px;
							height: auto !important;
							.qili{
								font-size: 14px;
								color: #222222;
								cursor: pointer;
								line-height: 15px;
								margin: 0 30px 35px 0;
							}
							.qiactive{
								color: #0289f4;
							}
						}
					}
				}
			}
			.zongbox{
				background-color: #ffffff;
				padding-bottom: 40px;
				.zongtop{
					display: flex;
					align-items: center;
					height: 60px;
					padding: 0 35px;
					border-bottom: 1px solid #eeeeee;
					.zongtitle{
						font-size: 17px;
						color: #0289f4;
						line-height: 57px;
						border-bottom: 2px solid #0289f4;
					}
				}
				.pinbox{
					padding: 20px 0 10px 20px;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					.pinli{
						cursor: pointer;
						width: 315px;
						height: 400px;
						background-color: #f9f9f9;
						margin: 0 20px 20px 0;
						padding: 20px 20px 0;
						transition: all 0.5s;
						.pinpic{
							width: 100%;
							height: 192px;
						}
						.pintitle{
							font-size: 18px;
							color: #222222;
							font-weight: bold;
							padding: 15px 0 12px;
						}
						.pinyao{
							display: flex;
							align-items: center;
							padding-bottom: 23px;
							.yaotxt{
								padding: 4px 10px;
								border: 1px solid #0289f4;
								border-radius: 3px;
								font-size: 12px;
								color: #0289f4;
							}
						}
						.pintxt{
							font-size: 15px;
							color: #888888;
							padding-bottom: 12px;
							span{
								font-size: 15px;
								color: #555555;
								padding-bottom: 10px;
							}
						}
					}
					.pinli:hover{
						transform: translateY(-2%);
						box-shadow: 0 0 6px #cccccc;
						.pintitle{
							font-size: 18px;
							color: #0289f4;
							font-weight: bold;
							padding: 15px 0 12px;
						}
					}
				}
				.fenbox{
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
		.tongright{
			width: 335px;
			padding: 27px 20px 40px;
			background-color: #ffffff;
			.hottop{
				display: flex;
				align-items: center;
				padding-bottom: 10px;
				border-bottom: 3px solid #f5f5f5;
				position: relative;
				.firepic{
					width: 24px;
					height: 30px;
				}
				.hottitle{
					font-size: 20px;
					color: #222222;
					font-weight: bold;
					padding-left: 10px;
				}
				.chengline{
					height: 3px;
					background-color: #ff4200;
					position: absolute;
					left: 0;
					bottom: -3px;
					width: 120px;
				}
			}
			.zhenbox{
				cursor: pointer;
				display: flex;
				align-items: center;
				padding-top: 40px;
				.zhenpic{
					width: 110px;
					height: 78px;
					flex-shrink: 0;
				}
				.zhenyou{
					padding-left: 14px;
					flex-grow: 1;
					.zhentitle{
						font-size: 15px;
						max-width: 150px;
						color: #222222;
					}
					.dantxt{
						font-size: 14px;
						color: #888888;
						max-width: 150px;
						padding-top: 16px;
						span{
							font-size: 14px;
							color: #222222;
						}
					}
				}
			}
			.zhenbox:hover{
				.zhentitle{
					color: #0289f4;
				}
			}
		}
	}

	.banxin {
		width: 1400px;
		margin: 0 auto;
	}
	@media screen and (max-width: 1200px) {
		.banxin{
			width: 98%;
			margin: 0 auto;
			display: block;
			overflow: hidden;
		}
		.tongbox .tongright{
			display: none;
		}
		.bg{
			margin-top: 15rem;
		}
		.tongbox .tongleft .tongtop .qibox .qileft{
			width: 30%;
			font-size: 1.4rem;
		}
		.tongbox .tongleft .tongtop .qibox .qiyou .qili{
			font-size: 1.4rem;
		}
		.tongbox .tongleft .tongtop .qibox .zhuleft{
			width: 30%;
			font-size: 1.4rem;
			line-height: 2.5rem;
		}
		.tongbox .tongleft .tongtop .qibox .zhuyou .zhulileft .qili{
			font-size: 1.4rem;
		}
		.tongbox .tongleft .tongtop .qibox .zhuyou .kaibox .kaititle{
			font-size: 1.4rem;
		}
		.tongbox .tongleft .tongtop .qibox .zhuyou .kaibox{
			width: 8rem;
		}
		.tongbox .tongleft .tongtop .qibox .yiyileft{
			width: 30%;
			font-size: 1.4rem;
			line-height: 2.5rem;
		}
		.tongbox .tongleft .zongbox .zongtop{
			height: 4.5rem;
		}
		.tongbox .tongleft .zongbox .zongtop .zongtitle{
			font-size: 1.8rem;
			line-height: 4.5rem;
		}
		.tongbox .tongleft{
			width: 100%;
		}
		.tongbox .tongleft .zongbox .pinbox{
			justify-content: space-between;
		}
		.tongbox .tongleft .zongbox .pinbox .pinli{
			width: 48%;
			margin: 0 0 2rem;
			height: 27rem;
		}
		.tongbox .tongleft .zongbox .pinbox .pinli .pinpic{
			height: 15rem;
		}
		.tongbox .tongleft .zongbox .pinbox .pinli .pintitle{
			font-size: 1.8rem;
		}
		.tongbox .tongleft .zongbox .pinbox .pinli .pinyao .yaotxt{
			font-size: 1.4rem;
		}
		.tongbox .tongleft .zongbox .pinbox .pinli .pintxt{
			font-size: 1.4rem;
		}
		.tongbox .tongleft .zongbox .pinbox .pinli .pintxt span{
			font-size: 1.4rem;
		}
		.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
			font-size: 1.6rem !important;
		}
	}
</style>